export default __webpack_public_path__ + "static/media/cargo.69f73663.png";